import React from 'react';

import { WebCopy, Input } from 'components';

interface SubDomainInputProps {
  className: any;
  subDomainLabel: any;
  subdomain: any;
  errors: any;
  handleSubDomainChanged: any;
}

export const SubDomainInput: React.FC<SubDomainInputProps> = ({
  className,
  subDomainLabel,
  subdomain,
  errors,
  handleSubDomainChanged,
}) => {
  return (
    <>
      <Input
        className={className}
        error={!!errors.subdomain}
        fullWidth
        type={'text'}
        value={subdomain}
        suffix={<span>{subDomainLabel}</span>}
        onChange={handleSubDomainChanged}
      />
      {!!errors.subdomain ? <WebCopy type="Error">{errors.subdomain}</WebCopy> : null}
    </>
  );
};
